module.exports = "<style></style> <div id=izvestaj-pozadina class=izvestaj-pozadina> <div class=izvestaj> <p id=tekst class=izvestaj-tekst></p> <p id=potpis class=izvestaj-potpis></p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/komponente/izvestaj/sablon.html
// module id = 35
// module chunks = 0